import clientInfoReducer from './clientInfoReducer';
import settingsReducer from './settingsReducer';
import fetchStateReducer from '../../../libs/utils/fetchStateReducer';
import resetStateReducer from '../../../libs/utils/resetStateReducer';
import * as types from '../actionTypes';
import { reducer as actionReducer } from '../../Action';
import { reducer as imagesReducer } from '../../Image';

const actionTypes = {
    isLoadingActionType:[types.fetchCard],
    successActionType:[types.fetchCardSuccess],
    errorActionType:[types.fetchCardError]
};

const defaultCardSettings = {
    headerSettings: {
      title: "",
      titleFontWeight: 100,
      subTitle: "",
      avatar: "",
      headerImage: {
        images:{
          small:'',
          medium:'',
          large:''
        }
      }
    },
    backgroundSettings:{
      backgroundColor: "#ffff", 
      backgroundImage: null
    },
    bodySettings:{
      fontColor: '#ffff',
      direction: 'rtl'
    },
    actionsSettings: {
      color:"#ffff",
      textColor:"#ffff",
    },
    detailsSettings:{
      servicesTitle:'שירותים:',
      openingHoursTitle:'שעות פעילות'
    },
    shareSettings:{
      title:'שתפו את כרטיס הביקור באמצעות:'
    },
    footerSettings: {
      title:'כרטיס הביקור נבנה ע"י Smartcard',
      buttonText:"לפרטים נוספים",
      link:'https://www.instagram.com/smart_card_/',
    }
  };
  
  const ClientInfo = {
    businessname:'',
    phoneNumber:'',
    whatsapp:'',
    location:'',
    facebook:'',
    instagram:'',
    about:'',
    openingHours:'',
    servicesDescription:'',
    status: 'NEW'
  }
  
  const EditorSettings = {
  
    mode: 'EDIT',
    previewResolution: {
      width:'800px',
      height:'1280px'
    }
  
  };
  
  const initialState = {
      settings: defaultCardSettings,
      clientInfo: ClientInfo,
      cardActions: {
        actions:[],
        deletedActions:[]
      },
      images: {
        avatar:null,
        backgroundImage:null,
        headerImage:null,
        galleryImages:[],
        deletedImages:[]
      }
 }

const businessCardReducer = (state = initialState ,action) => {
    
    console.log("business card reducer")
    console.log(action.type)
    switch(action.type){

        case types.copyCard:
            return { 
                ...state,
                status: 'NEW',
                clientInfo: clientInfoReducer(state.clientInfo,action),
                settings: settingsReducer(state.settings,action),
                cardActions: actionReducer(state.cardActions,action),
                images: imagesReducer(state.images,action)
            }
        
        case types.openCardModal:
          return{
            ...state,
            isModalOpen: true
          }
        
        case types.closeCardModal:
          console.log(action)
          return{
            ...state,
            isModalOpen: false
          }

        default:
            const newState = { 
                ...state,
                clientInfo: clientInfoReducer(state.clientInfo,action),
                settings: settingsReducer(state.settings,action),
                cardActions: actionReducer(state.cardActions,action),
                images: imagesReducer(state.images,action)
            }
            // console.log("default businesscardreducer")
            // console.log(newState);
            return newState;
    }

}

// const reducerWithReset = resetStateReducer(types.resetCard,initialState.businessCards)(businessCardReducer);
const reducerWithFetchAndReset = fetchStateReducer(actionTypes)(businessCardReducer);

export default reducerWithFetchAndReset;